import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import Vuelidate from 'vuelidate'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Donut from 'vue-css-donut-chart'
import 'vue-css-donut-chart/dist/vcdonut.css'
import VueBreadcrumbs from 'vue-breadcrumbs'
import axios from 'axios'
import vuetify from '@/plugins/vuetify' // path to vuetify export
import networkStatus from './plugins/networkStatus'; // to check networ status
import VueStickyDirective from "@renatodeleao/vue-sticky-directive"
import vSelect from 'vue-select'
import panZoom from 'vue-panzoom'
import Viewer from 'v-viewer'
import VScrollSync from 'v-scroll-sync';
import QuickActions from '@/components/Reusable Components/QuickActions'
import BulkQuickActions from '@/components/Reusable Components/BulkQuickActions'
import '@babel/polyfill'
export const EventBus = new Vue();
import VueCookie from 'vue-cookie';
import { readCookieSession } from '@/utils/sharedSession';

Vue.use(VueBreadcrumbs, {
    template: '<nav class="breadcrumb" v-if="$breadcrumbs.length"> ' +
        '<router-link class="breadcrumb-item" v-for="(crumb, key) in $breadcrumbs" :to="linkProp(crumb)" :key="key">{{ crumb | crumbText }}</router-link> ' +
        '</nav>'
});
Vue.use(VueCookie);
Vue.use(VScrollSync)
Vue.use(Viewer)
library.add(fas)
Vue.use(panZoom);
Vue.component('v-select', vSelect)
Vue.component("QuickActions", QuickActions)
Vue.component("BulkQuickActions", BulkQuickActions)
Vue.use(networkStatus)
Vue.use(VueStickyDirective);
Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.use(Vuelidate)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.prototype.$log = console.log.bind(console)
Vue.use(Donut)
Vue.use(VueBreadcrumbs);
Vue.use(require('vue-moment'));

if (process.env.VUE_APP_ENV === 'Staging' || process.env.VUE_APP_ENV === 'Pilot' || process.env.VUE_APP_ENV === 'Release') {
  console.log = function () {};
  console.debug = function () {}; // optional
  console.info = function () {};  // optional
}

new Vue({
  el: '#app',
  router,
  store,
  vuetify,
  created () {
    // Cookie-first hydration: if the shared cross-product cookie holds a session
    // (e.g. arriving from Supplier Portal), adopt it so we land authenticated.
    const shared = readCookieSession();
    if (shared && shared.token) {
      // adoptSharedSession rebuilds this app's {status, message, user} envelope
      // around the flat inner user in the cookie, so localStorage keeps its shape.
      this.$store.dispatch('auth/adoptSharedSession', shared);
    } else {
      // Fall back to this app's own stored session.
      const storedData = localStorage.getItem('user');
      const parsedData = JSON.parse(storedData);
      if (parsedData) {
        if (this.$cookie.get('mm_auth_key')) {
          parsedData['jwt'] = this.$cookie.get('mm_auth_key');
        }
        // SET_USER_DATA re-publishes the shared cookie on a shared domain, so
        // Supplier Portal can pick up a session that started here.
        this.$store.commit('auth/SET_USER_DATA', parsedData)
      }
    }

    // Live cross-product sync for an already-open tab.
    const reconcile = () => this.$store.dispatch('auth/reconcileFromShared');
    window.addEventListener('focus', reconcile);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') reconcile();
    });

    axios.interceptors.response.use(
      response => response,
      error => {
        if (error?.response?.status === 401) {
            this.$store.dispatch('auth/logout')
        }
        // if (error.response.message = 'Signature expired. Please try again') {
        //   alert("Signature expired. Please try again")
        //   this.$store.commit('auth/CLEAR_USER_DATA')
        //   // router.replace({ path: '/login' })
        // }
        return Promise.reject(error)
      }
    )
  },
  icons,
  template: '<App/>',
  components: {
    App
  }
})

// globally configured texts
Vue.prototype.$Bidtab = 'Bid tab'
Vue.prototype.$ViewBidtablisting = 'View Bid tab listing'